module.exports = __webpack_public_path__ + "static/media/viessmann.08337534.png";